export { getRecentGeneratedInvoicesWidgetContent } from './src/recently-generated-invoices-widget-content';
export { RecentlyGeneratedInvoicesQueryWrapper } from './src/recently-generated-invoices-query-wrapper';
